module.exports = __webpack_public_path__ + "static/img/yonghu@2x.f63933f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/yonghu@2x.png
// module id = VzvK
// module chunks = 1